export type ThemeScale<Type, Aliases extends string> = Array<Type> &
  Record<Aliases, Type>;
export type BreakpointAlias = "md";

const breakpoints = ["768px"] as ThemeScale<string, BreakpointAlias>;

[breakpoints.md] = breakpoints;

export default breakpoints;
